/**
 * Created by Ning Jiang on 2/8/2017.
 */

import { BitmapText, Sprite } from "pixi.js";
import { Currency, ICurrencyValueFormatOptions } from "@nolimitcity/slot-game/bin/core/balance/Currency";
import { SanGameConfig } from "../SanGameConfig";
import { IBitmapCountUpConfig, ICountUpAnimationConfig } from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import { TimelineLite, Timeline,Power3 } from "gsap";

export interface ISanCountUpAnimationConfig extends ICountUpAnimationConfig {
    withDecimals?:boolean;
}

export class SanBitmapCountUp extends BitmapText {

    private _numberFormat:ICurrencyValueFormatOptions | undefined;

    private _currentValue:number;

    private _originalFontSize:number;
    private _shrinkSize:boolean;
    private _maxTextWidth:number;

    private showDecimals:boolean = true;

    get shrinkSize():boolean {
        return this._shrinkSize;
    }

    set shrinkSize(value:boolean) {
        this._shrinkSize = value;
    }

    get maxTextWidth():number {
        return this._maxTextWidth;
    }

    set maxTextWidth(value:number) {
        this._maxTextWidth = value;
        if(this.parent) {
            this.updateCountUpTextPivot();
        } 
    }

    get currentValue():number {
        return this._currentValue;
    }

    set currentValue(value:number) {
        this._currentValue = value;
    }

    get scaling():number {
        return this.scale.x;
    }

    set scaling(value:number) {
        this.scale.set(value);
    }

    constructor(config:IBitmapCountUpConfig) {
        super("0", {
            fontName: config.style.font.name!,
            fontSize:config.style.font.size,
            align:config.style.align,
            tint:config.style.tint || 0xffffff
        });
        this._numberFormat = config.numberFormat;
        this._originalFontSize = (<{ name:string, size:number }>config.style.font).size;
        this.anchor = new PIXI.Point(0.5,0.5);
    }

    public getCountUpAnimation(fromValue:number, toValue:number, animationConfig:ISanCountUpAnimationConfig, onCompleteCallback?:() => void):Timeline | null {
        animationConfig.scaling = animationConfig.scaling || {from : 1, to : 1};

        this.showDecimals = animationConfig.withDecimals == undefined ? true : !!animationConfig.withDecimals;

        this.showValue(0);

        const countUpTween:TimelineLite = new TimelineLite();
        countUpTween.fromTo(
            this, animationConfig.duration,
                {
                    currentValue : fromValue,
                },
                {
                    currentValue : toValue,
                    ease : animationConfig.ease ? animationConfig.ease : Power3.easeInOut,
                    onStart : () => {
                        this.onCountUpUpdate();
                    },
                    onUpdate : () => this.onCountUpUpdate(),
                    onComplete : () => {
                        if(onCompleteCallback) {
                            onCompleteCallback();
                        }
                    }
                })
        ;
        return countUpTween;
    }

    public showValue(value:number, convert:boolean = false):void{
        this._currentValue = value;
        this.showDecimals = true;
        this.onCountUpUpdate();
    }

    private onCountUpUpdate():void {
        if(this.showDecimals)
            this.text = Currency.formatValue(this._currentValue, this._numberFormat);
        else
            this.text = Currency.formatValue(this._currentValue, this._numberFormat).split(".")[0]+ "X";

        // Should always update the pivot : SH
        this.updateCountUpTextPivot();
    }

    public updateCountUpTextPivot():void {
        // Update transform so that the textWidth are updated.
        this.updateTransform();

        if(this._shrinkSize) {
            if(this._maxTextWidth == null || this._maxTextWidth <= 0) {
                this._maxTextWidth = SanGameConfig.instance.GAME_WIDTH;
            }
            while(this.textWidth * this.scaling > this._maxTextWidth) {
                this.scaling = this.scaling * 0.995;
                this.updateTransform();
            }
        }

/*
        const fontScaleDiff:number =  this.fontSize!/this._originalFontSize;

        let posX:number = 0;
        let totWidth:number = 0;
        // 68 = font info
        let fontMaxX:number = 68;
        let indexDot:number = this.text.indexOf(".");
        for(let c:number = 0; c < this.children.length;c++){
            const sp:Sprite = (this.children[c] as Sprite);

            let spWidth:number = sp.texture.width;
            if(indexDot != c) spWidth += fontMaxX-spWidth;
            let spWidthBef:number = c == 0 ? 0 : (this.children[c-1] as Sprite).texture.width;
            const offsetX:number = c == 0 ? 0 : (spWidthBef - spWidth)*0.5;

            posX += (spWidth+offsetX)*fontScaleDiff;
            totWidth += spWidth;
            sp.position.x = posX;
            // sp.anchor.set(0.5,0.5);
        }

        this.pivot.set(totWidth*0.5,0);*/
    }
}